import { configureStore } from '@reduxjs/toolkit';
import { connectRouter } from 'connected-react-router';

import userInfoReducer from './slices/userInfoSlice';
import userSettingsReducer from './slices/userSettingsSlice';
import firmInfoReducer from './slices/firmInfoSlice';
import contactInfoReducer from './slices/contactInfoSlice';
import taskInfoReducer from './slices/taskInfoSlice';
import documentsReducer from './slices/documentsSlice';
import clientsInfoReducer from './slices/clientsInfoSlice';
import loginsReducer from './slices/loginsSlice';
import apiResponseInfoReducer from './slices/apiResponseInfoSlice';
import accountsReducer from './slices/accountsSlice';
import miscReducer from './slices/miscSlice';
import firmsReducer from './slices/firmsSlice';
import casesReducer from './slices/casesSlice';
import personsReducer from './slices/personsSlice';
import referralsReducer from './slices/referralsSlice';
import thinReferralsReducer from './slices/thinReferralsSlice';
import emergencyContactsReducer from './slices/emergencyContactsSlice';
import orgContactsReducer from './slices/orgContactsSlice';
import orgTasksReducer from './slices/orgTasksSlice';
import outreachListsReducer from './slices/outreachListsSlice';
import outreachesReducer from './slices/outreachesSlice';
import missivesReducer from './slices/missivesSlice';
import notesReducer from './slices/notesSlice';
import treatmentProgramsReducer from './slices/treatmentProgramsSlice';
import facilitiesReducer from './slices/facilitiesSlice';
import statusTransitionsReducer from './slices/statusTransitionsSlice';
import distributionListsReducer from './slices/distributionListsSlice';
import campaignsReducer from './slices/campaignsSlice';
import inquiriesReducer from './slices/inquiriesSlice';
import alertsReducer from './slices/alertsSlice';
import insuranceInfosReducer from './slices/insuranceInfosSlice';
import vobsReducer from './slices/vobResolutionsSlice';
import vobFormInfosReducer from './slices/vobFormInfosSlice';
import callRailCallReducer from './slices/callRailCallsSlice';
import intendedInfoReducer from './slices/intendedInfoSlice';
import filterStatesReducer from './slices/filterStatesSlice';
import dashboardStatsReducer from './slices/dashboardStatsSlice';
import emrInfoReducer from './slices/emrInfoSlice';

export default (history, initialState = {}) => {
  return configureStore({
    reducer: {
      firms: firmsReducer,
      cases: casesReducer,
      persons: personsReducer,
      referrals: referralsReducer,
      thinReferrals: thinReferralsReducer,
      emergencyContacts: emergencyContactsReducer,
      orgContacts: orgContactsReducer,
      orgTasks: orgTasksReducer,
      outreachLists: outreachListsReducer,
      outreaches: outreachesReducer,
      missives: missivesReducer,
      notes: notesReducer,
      treatmentPrograms: treatmentProgramsReducer,
      facilities: facilitiesReducer,
      statusTransitions: statusTransitionsReducer,
      distributionLists: distributionListsReducer,
      campaigns: campaignsReducer,
      inquiries: inquiriesReducer,
      alerts: alertsReducer,
      insuranceInfos: insuranceInfosReducer,
      vobs: vobsReducer,
      vobFormInfos: vobFormInfosReducer,
      callRailCalls: callRailCallReducer,
      intendedInfo: intendedInfoReducer,
      filterStates: filterStatesReducer,
      dashboardStats: dashboardStatsReducer,
      firmInfo: firmInfoReducer,
      userInfo: userInfoReducer,
      userSettings: userSettingsReducer,
      taskInfo: taskInfoReducer,
      documents: documentsReducer,
      contactInfo: contactInfoReducer,
      clientsInfo: clientsInfoReducer,
      logins: loginsReducer,
      apiResponseInfo: apiResponseInfoReducer,
      accounts: accountsReducer,
      misc: miscReducer,
      emrInfo: emrInfoReducer,
    },
    router: connectRouter(history),
    preloadedState: initialState,
  });
};
